export default __webpack_public_path__ + "static/media/FAQ Report.a189d17b.svg";